










































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {Customer} from '@/entity/Customer';
import {Validation} from '@/utils/Validation';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {CustomerDto} from '@/dto/CustomerDto';
import PCCS from '@/static/city.json';

import XHeader from "@/views/KeShangAdmin/XHeader.vue";
import Footer from "@/views/KeShangAdmin/Footer.vue";
import KeRegisterHeader from "@/views/KeShangAdmin/KeRegisterHeader.vue";

@Component({
  components: {KeRegisterHeader, Footer, XHeader},
})
export default class KeShangRegister extends Vue {
  step = 1;
  v = Validation;
  customer = new Customer();
  nameList: string[] = [];
  shape = '国内';
  nations: string[] = ["美国", "日本", "新加坡", "英国", "法国",];
  currencys: string[] = ["人民币", "美元", "日元", "新元", "欧元"];
  provinces: string[] = [];
  citys: string[] = [];
  districts: string[] = [];


  initProvinces() {
    this.provinces = [];
    for (const provinceKey in PCCS) {
      this.provinces[provinceKey] = PCCS[provinceKey].provinceName;
    }
  }

  initCitys(){
    this.citys = [];
    for (const provinceKey in PCCS){
      if (PCCS[provinceKey].provinceName === this.customer.province) {
        for (const cityKey in PCCS[provinceKey].mallCityList){
          this.citys[cityKey] = PCCS[provinceKey].mallCityList[cityKey].cityName;
        }
        break;
      }
    }
  }

  initDistrict(){
    this.districts=[];
    for (const provinceKey in PCCS){
      if (PCCS[provinceKey].provinceName === this.customer.province) {
        for (const cityKey in PCCS[provinceKey].mallCityList){
          if (PCCS[provinceKey].mallCityList[cityKey].cityName === this.customer.city) {
            for (const districtKey in PCCS[provinceKey].mallCityList[cityKey].mallAreaList) {
              this.districts[districtKey] = PCCS[provinceKey].mallCityList[cityKey].mallAreaList[districtKey].areaName;
            }
            break;
          }
        }
      }
    }
  }

  countrySet() {
    if (this.shape === '国内') {
      this.customer.country = 1;
      this.customer.nation = '中国';
    } else {
      this.customer.country = 0;
    }
  }

  handleUpload(e: { xhr: XMLHttpRequest }) {
    // this.customer.businessLicense = e.xhr.responseText;
    const  url =e.xhr.responseText
    const  url1 = url.replace("http","https")
    const  url2 = url1.replace("ygpubfile.yong-gang.cn:80","ygpubfile.yong-gang.cn")
    // console.dir(url2)
    this.customer.businessLicense = url2;
  }

  handleLicense(e: { xhr: XMLHttpRequest }) {
    // this.customer.licenseAttachment = e.xhr.responseText;
    // console.log(e.xhr.responseText)
    const  url = e.xhr.responseText
    const  url1 = url.replace("http","https")
    const  url2 = url1.replace("ygpubfile.yong-gang.cn:80","ygpubfile.yong-gang.cn")
    this.customer.licenseAttachment = url2

  }

  async save() {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      await CustomerDto.save(this.customer);
      await this.$router.push({name: 'KeShangSelect'});
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    }
  }

  nameNotExist(i: string) {
    if (this.nameList.some(value => value === i)) {
      return '名称已被占用';
    }
    return true;
  }

  async updateNameList() {
    const customers = await CustomerDto.findAll(new Customer());
    customers.forEach(value => {
      this.nameList.push(value.name);
    });
  }

  private mounted() {
    this.customer.creatorId = SecurityUtils.getLoginUser().id as number;
    this.updateNameList();
    return;
  }
}
